import { SET_EMAIL } from "app/actionTypes";

export const updateEmail = email => {
	return {
		type: SET_EMAIL,
		email,
	};
};
